import { render, staticRenderFns } from "./SpeciesView.vue?vue&type=template&id=408bcd16"
import script from "./SpeciesView.vue?vue&type=script&lang=js"
export * from "./SpeciesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports